<template>
  <div class="select_consult_fluid w_100">
    <div class="select_consult between">
      <div class="law_quest_l">
        <div class="lal_title between">
          <div class="lat_tab flex_start">
            <div :class="{ lal_active: status == 0 }" @click="clitab(0)">
              热门咨询
            </div>
            <div :class="{ lal_active: status == 1 }" @click="clitab(1)">
              精选咨询
            </div>
          </div>
          <div class="mo">更多></div>
        </div>
        <div class="lal_content">
          <div class="lal_list">
            <div class="lal_item" v-for="(item, index) in 4" :key="index">
              <div class="cont_w flex_start ellipsis">
                <img src="~assets/question/w.png" />

                {{
                  `好，我想离婚了，我想起诉离婚，我也不懂，`
                    | toEllipsisFilter(40)
                }}
              </div>
              <div class="cont_d flex_start">
                <img src="~assets/question/d.png" />
                {{
                  `无法协议离婚的，应向法院起诉离婚。法院判决离婚的标准是夫妻感情是否确已破裂，如达到这一标准的，一般情况下会判离婚。婚姻法第三十`
                    | toEllipsisFilter(99)
                }}
              </div>
              <div class="cont_bom between">
                <div class="con_left flex_start">
                  <div>
                    <img src="~assets/base/small_rentou.png" />
                    <img src="~assets/base/small_rentou.png" class="m_15" />
                    <img src="~assets/base/small_rentou.png" class="m_15" />
                  </div>
                  <div class="FontSize14"><span>3</span>位律师回复</div>
                </div>
                <div class="cb_right flex_end">
                  <div class="tag">婚姻家庭</div>
                  <div class="center">
                    <img src="~assets/question/dingwei.png" class="adrimg" />
                    安徽-阜阳
                  </div>
                  <div>以帮助71人</div>
                </div>
              </div>
            </div>
          </div>
          <div class="law_adv ">
            <div class="title1">看一看大家最近都在搜哪些律师？</div>
            <div class="law_adv_con between text_center">
              <div class="law_adv_ti1 center">按行业找律师</div>
              <div>
                <lay-item-win
                  style="width: 180px; height: 216px"
                  :consult-or-more="false"
                />
              </div>
              <div class="law_adv_ti2 center">在线律师</div>
              <div>
                <lay-item-win
                  style="width: 180px; height: 216px"
                  :consult-or-more="false"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="law_quest_r">
        <div class="law_quest_rt">
          <div class="ti">
            <sub-title text="律师回复动态" />
          </div>
          <home-timeline class="timeline" :spl="12" :fonum="4" />
        </div>

        <zxlaw class="law_quest_rb" />
      </div>
    </div>
  </div>
</template>

<script>
import layItemWin from "../components/layItemWin";
import zxlaw from "../components/zxlaw";
import subTitle from "views/home/components/subTitle";
import homeTimeline from "views/home/components/homeTimeline/homeTimeline";
export default {
  components: {
    layItemWin,
    zxlaw,
    subTitle,
    homeTimeline,
  },
  data: () => ({
    status: 0,
  }),
  methods: {
    clitab(index) {
      this.status = index;
    },
  },
};
</script>
 <style lang="scss" scope>
.select_consult_fluid {
  background-color: #fff;
  .select_consult {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
    .law_quest_l {
      width: 810px;
      align-self: start;
      .lal_title {
        font-size: 18px;
        color: #333;
        height: 60px;
        line-height: 60px;
        background: #ffffff;
        border: 1px solid #f5f5f5;

        .lat_tab {
          .lal_active {
            height: 60px;
            border-bottom: 2px solid #0465ea;
          }
          div {
            padding: 0 9px;
            margin-left: 32px;
          }
        }
        .mo {
          font-size: 16px;
          margin-right: 28px;
          cursor: pointer;
        }
      }
      .lal_content {
        .lal_list {
          border: 1px solid #f5f5f5;
          padding: 0 40px 0 30px;
          .lal_item {
            padding: 29px 0;
            border-bottom: 1px solid rgba($color: #9999, $alpha: 0.4);
            &:last-child {
              border-bottom: none;
            }
            .m_15 {
              margin-left: -15px;
            }
            .cont_w,
            .cont_d {
              align-items: flex-start;
              img {
                width: 26px;
                height: 26px;
                margin-right: 16px;
              }
            }
            .cont_w {
              font-size: 16px;
              color: #333;
            }
            .cont_d {
              margin-top: 18px;
              font-size: 14px;
              color: #999;
            }
            .cont_bom {
              margin-top: 18px;
              font-size: 12px;
              color: #999;
              .con_left {
                img {
                  width: 40px;
                  height: 40px;
                }
                span {
                  color: #0465ea;
                  margin-left: 10px;
                }
              }
              .cb_right {
                > div {
                  margin-left: 16px;
                }
                .tag {
                  padding: 3px 10px;
                  background: #f7f7f7;
                  border-radius: 5px;
                  color: #666;
                }
                .adrimg {
                  margin-right: 6px;
                }
              }
            }
          }
        }
        .law_adv {
          padding-left: 28px;
          margin-top: 30px;
          .law_adv_con {
            margin-top: 30px;
            > div {
              width: 180px;
              height: 216px;
            }
            .law_adv_ti1 {
              font-size: 22px;
              color: #fff;
              background: url("~assets/question/bg001.png");
            }
            .law_adv_ti2 {
              font-size: 22px;
              color: #fff;
              background: url("~assets/question/bg001.png");
            }
          }
        }
      }
    }
    .law_quest_r {
      width: 360px;
      align-self: start;
      .law_quest_rt {
        width: 100%;
        background: #ffffff;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
        padding: 24px 0 24px 20px;
        align-self: flex-start;
        .ti {
          margin-bottom: 12px;
        }
        .timeline {
          margin-top: 30px;
        }
        .home-timeline-item__wrapper {
          padding-left: 76px;
        }
        .home-timeline-item__content {
          padding: 19px 0 31px 23px;
        }
      }
      .law_quest_rb {
        width: 360px;
        height: 406px;
        margin-top: 55px;
        box-shadow: 0px 2px 10px 1px #eee;
        padding: 40px 32px 0;
      }
    }
  }
}
</style>